import { render, staticRenderFns } from "./messageHandlePopup.vue?vue&type=template&id=84a849be&scoped=true"
import script from "./messageHandlePopup.vue?vue&type=script&lang=js"
export * from "./messageHandlePopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84a849be",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('84a849be')) {
      api.createRecord('84a849be', component.options)
    } else {
      api.reload('84a849be', component.options)
    }
    module.hot.accept("./messageHandlePopup.vue?vue&type=template&id=84a849be&scoped=true", function () {
      api.rerender('84a849be', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/messageHandlePopup.vue"
export default component.exports